import { Params } from "../interface/core.interface";

export class GetCategoriesAction {
  static readonly type = "[Category] Get";
}

export class GetLayerdCategoriesWithProductsAction {
  static readonly type = "[Category] Layerd Categories With Products Get";
}

export class GetProductsWithCategoriesSlugAction {
  static readonly type = "[Category] Products With Categories Slug Get";
  constructor(public slug: string) {}
}
export class GetDetailedCategoryBySlugAction {
  static readonly type = "[Category] Detailed Category By Slug Get";
  constructor(public slug: string) {}
}